// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeasonalDiscountUnibrow-cls1___6987a999822b4adeefd{/*!*/}.SeasonalDiscountUnibrow-cls2___03b80261f34db3889b3{color:#fff;font-size:14px;font-weight:400;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SeasonalDiscountUnibrow-cls1___6987a999822b4adeefd",
	"cls2": "SeasonalDiscountUnibrow-cls2___03b80261f34db3889b3 SeasonalDiscountUnibrow-cls1___6987a999822b4adeefd"
};
export default ___CSS_LOADER_EXPORT___;
